import * as React from 'react';
const DeleteIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#424242" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#171717"
        d="M6.09 17.083c-.416 0-.77-.147-1.065-.441a1.451 1.451 0 0 1-.442-1.065V5H3.75V3.75H7.5v-.737h5v.737h3.75V5h-.833v10.577c0 .42-.146.777-.438 1.069a1.454 1.454 0 0 1-1.069.437H6.09ZM14.167 5H5.833v10.577a.25.25 0 0 0 .072.184.25.25 0 0 0 .185.072h7.82a.245.245 0 0 0 .176-.08.245.245 0 0 0 .08-.176V5Zm-6.33 9.167h1.25v-7.5h-1.25v7.5Zm3.076 0h1.25v-7.5h-1.25v7.5Z"
      />
    </g>
  </svg>
);
export default DeleteIcon;
